"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundMerkleRootDocument = exports.RoundProposalCountDocument = exports.RoundIdDocument = exports.ManyRoundsWhereProposerOrVoterDocument = exports.ManyVotesDocument = exports.ManyManyVoteVotingPowersDocument = exports.ProposalDocument = exports.ManyProposalsDocument = exports.GlobalStatsDocument = exports.OrderDirection = exports.OrderBy_MetadataFields = exports.OrderBy_CheckpointFields = exports.OrderByVoteFields = exports.OrderBySummaryFields = exports.OrderByRoundFields = exports.OrderByProposalFields = exports.OrderByAccountFields = void 0;
var OrderByAccountFields;
(function (OrderByAccountFields) {
    OrderByAccountFields["FirstSeenAt"] = "firstSeenAt";
    OrderByAccountFields["Id"] = "id";
    OrderByAccountFields["ProposalCount"] = "proposalCount";
    OrderByAccountFields["VoteCount"] = "voteCount";
})(OrderByAccountFields || (exports.OrderByAccountFields = OrderByAccountFields = {}));
var OrderByProposalFields;
(function (OrderByProposalFields) {
    OrderByProposalFields["Body"] = "body";
    OrderByProposalFields["Id"] = "id";
    OrderByProposalFields["IsCancelled"] = "isCancelled";
    OrderByProposalFields["IsWinner"] = "isWinner";
    OrderByProposalFields["LastUpdatedAt"] = "lastUpdatedAt";
    OrderByProposalFields["MetadataUri"] = "metadataUri";
    OrderByProposalFields["ProposalId"] = "proposalId";
    OrderByProposalFields["Proposer"] = "proposer";
    OrderByProposalFields["ReceivedAt"] = "receivedAt";
    OrderByProposalFields["Round"] = "round";
    OrderByProposalFields["Title"] = "title";
    OrderByProposalFields["Tldr"] = "tldr";
    OrderByProposalFields["TxHash"] = "txHash";
    OrderByProposalFields["TxStatus"] = "txStatus";
    OrderByProposalFields["Version"] = "version";
    OrderByProposalFields["VotingPower"] = "votingPower";
    OrderByProposalFields["WinningPosition"] = "winningPosition";
})(OrderByProposalFields || (exports.OrderByProposalFields = OrderByProposalFields = {}));
var OrderByRoundFields;
(function (OrderByRoundFields) {
    OrderByRoundFields["Id"] = "id";
    OrderByRoundFields["MerkleRoot"] = "merkleRoot";
    OrderByRoundFields["ProposalCount"] = "proposalCount";
    OrderByRoundFields["RegisteredAt"] = "registeredAt";
    OrderByRoundFields["SourceChainRound"] = "sourceChainRound";
    OrderByRoundFields["State"] = "state";
    OrderByRoundFields["TxHash"] = "txHash";
    OrderByRoundFields["TxStatus"] = "txStatus";
    OrderByRoundFields["Type"] = "type";
    OrderByRoundFields["UniqueProposers"] = "uniqueProposers";
    OrderByRoundFields["UniqueVoters"] = "uniqueVoters";
    OrderByRoundFields["VotingPower"] = "votingPower";
})(OrderByRoundFields || (exports.OrderByRoundFields = OrderByRoundFields = {}));
var OrderBySummaryFields;
(function (OrderBySummaryFields) {
    OrderBySummaryFields["Id"] = "id";
    OrderBySummaryFields["ProposalCount"] = "proposalCount";
    OrderBySummaryFields["RoundCount"] = "roundCount";
    OrderBySummaryFields["UniqueProposers"] = "uniqueProposers";
    OrderBySummaryFields["UniqueVoters"] = "uniqueVoters";
})(OrderBySummaryFields || (exports.OrderBySummaryFields = OrderBySummaryFields = {}));
var OrderByVoteFields;
(function (OrderByVoteFields) {
    OrderByVoteFields["Id"] = "id";
    OrderByVoteFields["Proposal"] = "proposal";
    OrderByVoteFields["ReceivedAt"] = "receivedAt";
    OrderByVoteFields["Round"] = "round";
    OrderByVoteFields["TxHash"] = "txHash";
    OrderByVoteFields["TxStatus"] = "txStatus";
    OrderByVoteFields["Voter"] = "voter";
    OrderByVoteFields["VotingPower"] = "votingPower";
})(OrderByVoteFields || (exports.OrderByVoteFields = OrderByVoteFields = {}));
var OrderBy_CheckpointFields;
(function (OrderBy_CheckpointFields) {
    OrderBy_CheckpointFields["BlockNumber"] = "block_number";
    OrderBy_CheckpointFields["ContractAddress"] = "contract_address";
    OrderBy_CheckpointFields["Id"] = "id";
})(OrderBy_CheckpointFields || (exports.OrderBy_CheckpointFields = OrderBy_CheckpointFields = {}));
var OrderBy_MetadataFields;
(function (OrderBy_MetadataFields) {
    OrderBy_MetadataFields["Id"] = "id";
    OrderBy_MetadataFields["Value"] = "value";
})(OrderBy_MetadataFields || (exports.OrderBy_MetadataFields = OrderBy_MetadataFields = {}));
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (exports.OrderDirection = OrderDirection = {}));
exports.GlobalStatsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'globalStats' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'StringValue', value: 'SUMMARY', block: false },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'proposalCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'uniqueProposers' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'uniqueVoters' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyProposalsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyProposals' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderByProposalFields' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Proposal_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposals' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'proposer' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceChainRound' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataUri' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tldr' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isCancelled' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isWinner' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'winningPosition' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'receivedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'votingPower' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ProposalDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'proposal' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposal' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'proposer' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceChainRound' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadataUri' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tldr' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isCancelled' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isWinner' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'winningPosition' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'receivedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'votingPower' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyManyVoteVotingPowersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyManyVoteVotingPowers' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderByVoteFields' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Vote_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'votingPower' } }],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyVotesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyVotes' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderByVoteFields' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Vote_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'voter' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceChainRound' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'proposal' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'votingPower' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'receivedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyRoundsWhereProposerOrVoterDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyRoundsWhereProposerOrVoter' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'account' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposals' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'proposer' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'account' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'round_' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'state' },
                                                        value: { kind: 'StringValue', value: 'ACTIVE', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceChainRound' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votes' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'voter' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'account' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'round_' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'state' },
                                                        value: { kind: 'StringValue', value: 'ACTIVE', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceChainRound' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'roundId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceChainRound' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sourceChainRound' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'sourceChainRound' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundProposalCountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'roundProposalCount' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceChainRound' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sourceChainRound' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'sourceChainRound' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'proposalCount' } }],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundMerkleRootDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'roundMerkleRoot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceChainRound' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sourceChainRound' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'sourceChainRound' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'merkleRoot' } }],
                        },
                    },
                ],
            },
        },
    ],
};
